"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PageSlide = _interopRequireDefault(require("./PageSlide.scss"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PAGE_ID = 'page_';

var PageSlide = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PageSlide, _React$Component);

  var _super = _createSuper(PageSlide);

  function PageSlide(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PageSlide);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slidePageIn", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(mainDomEl, nextDomEl) {
        var mainEl, nextEl;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mainEl = document.getElementById(mainDomEl);
                nextEl = document.getElementById(nextDomEl);

                if (!(mainEl && nextEl)) {
                  _context.next = 30;
                  break;
                }

                if (_config["default"].isSafetureApp) {
                  _context.next = 18;
                  break;
                }

                mainEl.style.transform = 'translateX(-100px)';
                nextEl.style.transform = 'translateX(-45%)';
                _context.next = 8;
                return (0, _TimeoutHelper.timeout)(500);

              case 8:
                nextEl.classList.add(_PageSlide["default"].speedTransition);
                nextEl.style.transform = 'translateX(-55%)';
                _context.next = 12;
                return (0, _TimeoutHelper.timeout)(130);

              case 12:
                nextEl.style.transform = 'translateX(-50%)';
                _context.next = 15;
                return (0, _TimeoutHelper.timeout)(130);

              case 15:
                nextEl.classList.remove(_PageSlide["default"].speedTransition);
                _context.next = 30;
                break;

              case 18:
                mainEl.style.transform = 'translateX(-100px)';
                nextEl.style.transform = 'translateX(-20px)';
                _context.next = 22;
                return (0, _TimeoutHelper.timeout)(500);

              case 22:
                nextEl.classList.add(_PageSlide["default"].speedTransition);
                nextEl.style.transform = 'translateX(5px)';
                _context.next = 26;
                return (0, _TimeoutHelper.timeout)(130);

              case 26:
                nextEl.style.transform = 'translateX(0)';
                _context.next = 29;
                return (0, _TimeoutHelper.timeout)(130);

              case 29:
                nextEl.classList.remove(_PageSlide["default"].speedTransition);

              case 30:
                if (_this.props.pageChangeDoneCallback) setTimeout(function () {
                  return _this.props.pageChangeDoneCallback();
                }, 500);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slidePageOut", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(mainDomEl, nextDomEl) {
        var mainEl, nextEl, checkChild;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mainEl = document.getElementById(mainDomEl);
                nextEl = document.getElementById(nextDomEl);

                checkChild = function checkChild(child) {
                  if (child.scrollTop > 0 || child.className === _PageSlide["default"].main) setTimeout(function () {
                    return child.scrollTop = 0;
                  }, 550);else if (child.children.length > 0) checkChild(child.children[0]);
                };

                if (nextEl && nextEl.scrollTop > 0) nextEl.scrollTop = 0;else if (nextEl.children) checkChild(nextEl.children[0]);

                if (mainEl && nextEl) {
                  mainEl.style.transform = 'translateX(0)';
                  nextEl.style.transform = "translateX(".concat(window.innerWidth, "px)");
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPageStyles", function (mainPage, onFirstPage) {
      return {
        transform: !mainPage ? "translateX(".concat(window.innerWidth, "px)") : "translateX(0)",
        overflow: mainPage ? onFirstPage ? 'auto' : 'hidden' : 'hidden',
        top: !mainPage && !_DeviceInfoHelper["default"].isiOS() && !_DeviceInfoHelper["default"].isSafari() && _this.props.topPositionOnExtraPages || 0
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getHeightStyles", function (mainPage) {
      var heightClassNames;
      if (mainPage) return '';
      if (_this.props.showNavbar && _this.props.showBottomBar) heightClassNames = _this.props.height ? "".concat(_PageSlide["default"].withBottomBar) : "".concat(_PageSlide["default"].withBottomBarVh);else if (_this.props.showNavbar && !_this.props.showBottomBar) heightClassNames = _this.props.height ? "".concat(_PageSlide["default"].withoutBottomBar) : "".concat(_PageSlide["default"].withoutBottomBarVh);else if (!_this.props.showNavbar && _this.props.showBottomBar) heightClassNames = _this.props.height ? "".concat(_PageSlide["default"].withBottomBar) : "".concat(_PageSlide["default"].withBottomBarVh);else heightClassNames = _this.props.height ? "".concat(_PageSlide["default"].withoutBoth) : "".concat(_PageSlide["default"].withoutBothVh);
      heightClassNames = "".concat(heightClassNames, " ").concat(_PageSlide["default"].withoutBottomBarMax);
      return heightClassNames;
    });
    _this.state = {};
    _this.key = _StringHelper["default"].createShortId(5);
    return _this;
  }

  (0, _createClass2["default"])(PageSlide, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.index > prevProps.index) this.slidePageIn("".concat(PAGE_ID).concat(this.key).concat(prevProps.index), "".concat(PAGE_ID).concat(this.key).concat(this.props.index));else if (this.props.index < prevProps.index) this.slidePageOut("".concat(PAGE_ID).concat(this.key).concat(this.props.index), "".concat(PAGE_ID).concat(this.key).concat(prevProps.index));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if ((0, _isArray["default"])(this.props.children)) {
        var children = this.props.children.map(function (child, index) {
          var mainPage = index === 0;
          var onFirstPage = _this2.props.index === 0;
          var classNames = mainPage ? _this2.props.isInNuggetContainer ? _PageSlide["default"].mainInContainer : _PageSlide["default"].main : _this2.props.isInNuggetContainer ? _PageSlide["default"].extraInContainer : _PageSlide["default"].extra;
          if (!mainPage && _this2.props.isInNuggetContainer) classNames = _DeviceInfoHelper["default"].isSafari() ? _PageSlide["default"].browserExtraInContainerSafari : _PageSlide["default"].browserExtraInContainer;

          var heightClassNames = _this2.getHeightStyles(mainPage);

          var marginClassNames = !mainPage && _this2.props.showNavbar ? _this2.props.useSafeAreaForTopPadding ? "".concat(_PageSlide["default"].marginTop) : "".concat(_PageSlide["default"].marginTopNoSafeArea) : '';
          classNames = "".concat(classNames, " ").concat(heightClassNames, " ").concat(marginClassNames);
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: "".concat(PAGE_ID).concat(_this2.key).concat(index),
            key: "".concat(PAGE_ID).concat(_this2.key).concat(index),
            className: classNames,
            style: _this2.getPageStyles(mainPage, onFirstPage)
          }, child);
        });
        var containerClasses;
        var containerStyle = {};

        if (this.props.height) {
          containerStyle.height = this.props.height;
          containerClasses = "".concat(_PageSlide["default"].container);
        } else {
          containerClasses = "".concat(_PageSlide["default"].container, " ").concat(this.props.showNavbar ? _PageSlide["default"].withoutBottomBarVh : _PageSlide["default"].withBottomBarVh);
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: containerClasses,
          style: containerStyle
        }, children);
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", null, this.props.children);
      }
    }
  }]);
  return PageSlide;
}(_react["default"].Component);

PageSlide.propTypes = {
  id: _propTypes["default"].string,
  index: _propTypes["default"].number,
  children: _propTypes["default"].node,
  showNavbar: _propTypes["default"].bool,
  showBottomBar: _propTypes["default"].bool,
  height: _propTypes["default"].string,
  pageChangeDoneCallback: _propTypes["default"].func,
  topPositionOnExtraPages: _propTypes["default"].number,
  isInNuggetContainer: _propTypes["default"].bool,
  useSafeAreaForTopPadding: _propTypes["default"].bool
};
PageSlide.defaultProps = {
  index: 0,
  showNavbar: false,
  showBottomBar: true,
  height: null,
  topPositionOnExtraPages: null,
  isInNuggetContainer: false,
  useSafeAreaForTopPadding: true
};
var _default = PageSlide;
exports["default"] = _default;